import React from 'react'
import Button from '~/Common-Objects/UI/Forms/Button/Button'
import { connect } from 'react-redux';

@connect((store) => {
    return { user: store.user, siteMaster: store.siteMaster }
})
export default class HubspotDisconnect extends React.Component {

    constructor(props) {
        super(props);
    }

    render() {

        return <div>

            <h4 className="mar-b25">Really Disconnect?</h4>
            <div className="mar-b25">Are you sure you want to disconnect Nimble from {this.props.siteMaster.siteName}?</div>
            <div className="mar-b25">If you disconnect, your contacts will remain here but we will stop syncing with your Nimble account.</div>

            <Button text="Disconnect!" className="button-primary" onClick={this.props.goDisconnect} />

        </div>
    }
};

